module.exports = __webpack_public_path__ + "img/Mensa.a3c9e01f.png";